import { Navbar, Nav, Container, Image, NavDropdown } from 'react-bootstrap'
import {FaChevronDown} from 'react-icons/fa'
import Link from 'next/link'
import Authenticator from '@group-devs/yfp7-authenticator'
import { Request } from '@group-devs/yfp7-global-modules'
import params from '../data/params'
import { useEffect, useState } from 'react';
import { isDomain } from '../utils/general'

const request = new Request(process.env.apiDomain)

const TopNav = (props) => {
    
    const endPoint = process.env.s3EndPoint.replace('https://','');
    const bucketName = process.env.s3Bucket;
    const IMAGE_PATH = 'https://'+bucketName+'.'+endPoint;

    const contactId = props.auth.site_user ? props.auth.contactId : null
    const accountId = props.site.accountId;
    const [email, setEmail] = useState('');
    const [authKey, setAuthKey] = useState('');

    const {data: profile} = request.account.swrAccountProfile(accountId);
    const {data: contactAccount} = request.contacts.swrAccount(contactId)

    //const {data: business} = request.website.swrSite(accountId, "BC")
    const {data: wellness} = request.website.swrSite(accountId, "WC")

    const wellnessUrl = wellness ? (isDomain(wellness.url) ? 'https://www.'+wellness.url : 'https://'+wellness.url) : '';

    const fullname = profile ? profile.first_name+' '+profile.last_name : '';
    const siteName = props.site && props.site.name ? props.site.name : fullname;

    const userId = props.auth.isAuthenticated ? props.auth.userId : null;
    const {data: user} = request.account.swrUserProfile(userId);

    const hideLinks = props.hideLinks ? props.hideLinks : false;

    if(props.auth.isAuthenticated)
    {
        const firstname = user ?  user.first_name : '';
        const lastname = user ?  user.last_name : '';

        var loginUser = firstname.slice(0,1)+lastname.slice(0,1);
    }
    else
    {
        const fname = profile ? profile.first_name : '';
        const lname = profile ? profile.last_name : '';

        var loginUser = fname.slice(0,1)+lname.slice(0,1);
    }

    const avatar = user ? user.avatar : (contactAccount && contactAccount.contact.profile.image != null ? IMAGE_PATH+'/'+contactAccount.contact.profile.image : '');
    const authUrl = process.env.authDomain

    useEffect(() => {
        const Email = user ? user.user.email : '';
        const Key = user ? user.user.auth_key : '';

        setEmail(Email);
        setAuthKey(Key);

    }, [user])

    return (
    <Navbar expand="lg">
        <Container fluid className="px-xl-3 px-0">
            {
                /*props.customize ? 

                    (props.site.brand ? 
                        <Navbar.Brand  className="p-0"><Image width={60} height={60} src={props.site.brand} className="mw-100 mr-3 d-inline-block" alt="avatar"  roundedCircle/><span>{ fullname }</span></Navbar.Brand>
                        :
                        <Navbar.Brand href={"//" + props.home} className="p-0"><div className="mw-100 mr-3 d-inline-block no-avatar" >{loginUser}</div><span>{ fullname }</span></Navbar.Brand>
                    )

                :
                /*(*/props.home ?
                    (props.site.brand ? 
                        <Navbar.Brand href={props.customize ? "#" : "//" + props.home} className="p-0"><Image width={60} height={60} src={props.site.brand} className="mw-100 mr-3 d-inline-block some1" alt="avatar"  roundedCircle/><span>{ siteName }</span></Navbar.Brand>
                         :
                         <Navbar.Brand href={props.customize ? "#" : "//" + props.home} className="p-0"><div className="mw-100 mr-3 d-inline-block no-avatar" >{loginUser}</div><span>{ siteName }</span></Navbar.Brand>
                    )
                    :
                    <Link href={props.customize ? "#" :"/"} passHref>
                        {(props.site.brand ? 
                            <Navbar.Brand className="p-0"><Image width={60} height={60} src={props.site.brand} className="mw-100 mr-3 d-inline-block some2" alt="avatar" roundedCircle /><span>{ siteName }</span></Navbar.Brand>
                            :
                            <Navbar.Brand href={props.customize ? "#" : "//" + props.home} className="p-0"><div className="mw-100 mr-3 d-inline-block no-avatar" >{loginUser}</div><span>{ siteName }</span></Navbar.Brand>
                        )}
                    </Link>
                //)
            }
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-auto align-items-lg-center">
                    {hideLinks ? "": <>
                        {props.customize ?
                        <Nav.Link href="#" className="py-lg-0 py-3 ml-lg-3 text-reset">Home</Nav.Link>
                        :
                        (props.home ?
                            <Nav.Link href={"//" + props.home} className="py-lg-0 py-3 ml-lg-3 text-reset">
                                Home
                            </Nav.Link>
                            :
                            <Link href="/" passHref>
                                <Nav.Link className="py-lg-0 py-3 ml-lg-3 text-reset">
                                Home
                                </Nav.Link>
                            </Link>
                        )
                        }
                        {props.navigation.map( (nav, key) => {
                            //if (props.customize)
                                //return <Nav.Link key={key} className={`${nav.label.replace(/\s/g, '')} text-lg-center py-3 nav-link text-reset`} >{nav.label}</Nav.Link>
                            let siteUrl = new URL("http://" + props.host)
                            let navUrl = nav && nav.href != "#"  ? new URL("http:" + nav.href) : ''
                            if (navUrl.hostname == siteUrl.hostname)
                                return <Link href={props.customize ? '#' : navUrl.pathname} key={key} passHref><Nav.Link className={`${nav.label.replace(/\s/g, '')} text-lg-center py-3 nav-link text-reset`} target={nav.isClient ? "_blank" : null}>{nav.label}</Nav.Link></Link> 
                            else
                                return <Nav.Link href={props.customize ? '#' : nav.href} key={key} className={`${nav.label.replace(/\s/g, '')} text-lg-center py-3 nav-link text-reset`} target={nav.isClient ? "_blank" : null}>{nav.label}</Nav.Link> 
                        } ) }
                        
                        {
                            props.customize ? 
                            ((!props.auth.isAuthenticated) ?
                                <Link href={props.home ? '/login?redirect=/home' :'/login?redirect=/choose-destination'} passHref>
                                    <Nav.Link className="py-lg-0 py-3 login">Login</Nav.Link>
                                </Link>
                            :
                                <>
                                    <NavDropdown title={<>{(props.site.brand ? <Image width={30} height={30} src={avatar ? avatar : '/images/profile-default.jpg'} className="mw-100 mr-2 d-inline-block" alt="avatar" roundedCircle /> : <div className="mw-100 mr-2 d-inline-block no-avatar" >{loginUser}</div>) } <FaChevronDown/> </>} id="basic-nav-dropdown">
                                        {
                                            props.auth.site_owner ? 
                                            <>
                                                <NavDropdown.Item target="_blank" href={props.customize ? "#" : authUrl+'autologin?ref='+authKey+'&redirect=account-profile'} className="px-lg-3 login dropdown-item">My Profile</NavDropdown.Item>
                                                <NavDropdown.Item target="_blank" href={props.customize ? "#" : authUrl+'autologin?ref='+authKey+'&redirect=account-billing'} className="px-lg-3 login dropdown-item">Billing</NavDropdown.Item>
                                                <NavDropdown.Item target="_blank" href={props.customize ? "#" : authUrl+'autologin?ref='+authKey+'&redirect=account-settings'} className="px-lg-3 login dropdown-item">Settings</NavDropdown.Item>
                                                <NavDropdown.Item target="_blank" href={props.customize ? "#" : authUrl+'autologin?ref='+authKey+'&redirect=account-products'} className="px-lg-3 login dropdown-item">My Products</NavDropdown.Item>
                                            </>
                                            :
                                            <>
                                                <NavDropdown.Item href={wellnessUrl+'/myprofile'} className="px-lg-3 login dropdown-item">My Profile</NavDropdown.Item>
                                            </>

                                        }
                                        <NavDropdown.Item href={props.customize ? "#" : process.env.yfpDomain+'wea'} className="px-lg-3 login dropdown-item">My Courses</NavDropdown.Item>
                                        <NavDropdown.Item href={props.customize ? "#" : process.env.yfpDomain+'shop'} className="px-lg-3 login dropdown-item">Shop</NavDropdown.Item>
                                        {
                                            props.customize ?
                                            <NavDropdown.Item className="px-lg-3 login dropdown-item">Log out</NavDropdown.Item>
                                            :
                                            <NavDropdown.Item onClick={() => Authenticator.preLogout('/') } className="px-lg-3 login dropdown-item">Log out</NavDropdown.Item>
                                        }
                                        
                                    </NavDropdown>
                                    <Link href={props.customize ? '#' : "https://" + props.home+"/home"}>
                                        <a className={props.site.site.code == "BC" ? "nav-link text-decoration-none text-white text-center my-3 btn-dark-blue rounded-pill nav-link hubdashboard" :  "nav-link text-decoration-none text-white text-center my-3 btn-blue rounded-pill nav-link hubdashboard"}>Enter</a>
                                    </Link>
                                </>
                            )
                            :
                            ((!props.auth.isAuthenticated) ?
                                <Link href={props.home ? '/login?redirect=/home' :'/login?redirect=/choose-destination'} passHref>
                                    <Nav.Link className="py-lg-0 py-3 login">Login</Nav.Link>
                                </Link>
                            :
                                <>
                                    <NavDropdown title={<> {(props.site.brand ? <Image width={30} height={30} src={avatar ? avatar : '/images/profile-default.jpg'} className="mw-100 mr-2 d-inline-block" alt="avatar" roundedCircle/> : <Image width={30} height={30} src="/images/profile-default.jpg" className="mw-100 mr-2 d-inline-block" alt="avatar" roundedCircle/>) }  <FaChevronDown/> </>} id="basic-nav-dropdown">
                                        {
                                            props.auth.site_owner ? 
                                            <>
                                                <NavDropdown.Item target="_blank" href={props.customize ? "#" : authUrl+'autologin?ref='+authKey+'&redirect=account-profile'} className="px-lg-3 login dropdown-item">My Profile</NavDropdown.Item>
                                                <NavDropdown.Item target="_blank" href={props.customize ? "#" : authUrl+'autologin?ref='+authKey+'&redirect=account-billing'} className="px-lg-3 login dropdown-item">Billing</NavDropdown.Item>
                                                <NavDropdown.Item target="_blank" href={props.customize ? "#" : authUrl+'autologin?ref='+authKey+'&redirect=account-settings'} className="px-lg-3 login dropdown-item">Settings</NavDropdown.Item>
                                                <NavDropdown.Item target="_blank" href={props.customize ? "#" : authUrl+'autologin?ref='+authKey+'&redirect=account-products'} className="px-lg-3 login dropdown-item">My Products</NavDropdown.Item>
                                            </>
                                        :
                                            <>
                                                <NavDropdown.Item href={props.customize ? "#" : wellnessUrl+'/myprofile'} className="px-lg-3 login dropdown-item">My Profile</NavDropdown.Item>
                                            </>
                                        }
                                        <NavDropdown.Item href={props.customize ? "#" : process.env.yfpDomain+'wea'} className="px-lg-3 login dropdown-item">My Courses</NavDropdown.Item>
                                        <NavDropdown.Item href={props.customize ? "#" : process.env.yfpDomain+'shop'} className="px-lg-3 login dropdown-item">Shop</NavDropdown.Item>
                                        {
                                            props.customize ? 
                                            <NavDropdown.Item className="px-lg-3 login dropdown-item">Log out</NavDropdown.Item>
                                            :
                                            <NavDropdown.Item onClick={() => Authenticator.preLogout('/') } className="px-lg-3 login dropdown-item">Log out</NavDropdown.Item>

                                        }
                                        
                                    </NavDropdown>
                                    <Link href={props.customize ? "#" : (props.site.site.code == 'HUB' ? "/choose-destination" : "/home")}>
                                        <a className={props.site.site.code == "BC" ? "nav-link text-decoration-none text-white text-center my-3 btn-dark-blue rounded-pill nav-link hubdashboard" : "nav-link text-decoration-none text-white text-center my-3 btn-blue rounded-pill nav-link hubdashboard"}>Enter</a>
                                    </Link>
                                </>
                            )
                        }</>
                    }
                </Nav>
            </Navbar.Collapse>
        </Container>
        <style jsx global>{`
            .font-weight-900{
                font-weight:900!important;
            }

            nav{
                font-family: "museo-sans", sans-serif;
            }
                        
            .nav-link{                
                line-height: 1.5;
                font-size: .9rem;
                margin: 0 .25rem;
            }

            .login{
                font-size: .9rem;
                color: #1b1b1b!important;
            }
                        
            .hubdashboard{
                font-size: .75rem;
                padding: .5rem 1rem!important;
                font-family: 'museo-sans-500';
                letter-spacing: .2px;
                max-width: 110px;
                text-transform: capitalize!important;
                
            }
                        
            .navbar{
                -webkit-box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.23);
                -moz-box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.23);
                box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.23);
                background-color: #f9f8f6;
            }
                        
            .navbar-toggler{
                padding:.5rem!important
            }
                        
            .dropdown-item.active, .dropdown-item:active,
            .dropdown-item:focus, .dropdown-item:hover{
                background-color:#fff;
            }
                        
            .dropdown-toggle{
                display: flex;
                align-items: center;
            }
                        
            .dropdown-toggle::after{
                display: none;
            }
                        
            .dropdown-toggle svg{
                font-size: 10px;
            }

            .no-avatar {
                width: 2rem;
                height: 2rem;
                line-height: 2rem;
                border-radius: 50%;
                display: inline-block;
                background: #ced4da no-repeat center/cover;
                position: relative;
                text-align: center;
                color: #868e96;
                font-weight: 600;
                vertical-align: bottom;
                font-size: .875rem;
            }
            
        `}</style>
    </Navbar>
)
}

export default TopNav;